import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../styles/main.css';

const Checkout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { item, qty } = location.state || {};

  if (!item || !qty) {
    return (
      <div className="royal-background" style={{ padding: '2rem', color: '#fff', textAlign: 'center' }}>
        <h2>No item selected</h2>
        <button onClick={() => navigate('/menu')} className="primary-btn" style={{ marginTop: '1rem' }}>
          Go Back to Menu
        </button>
      </div>
    );
  }

  const totalPrice = item.price * qty;

  const handlePayment = () => {
    // Simulate payment and redirect to thank you page
    setTimeout(() => {
      navigate('/thankyou', { state: { item, qty, totalPrice } });
    }, 1000);
  };

  return (
    <div className="royal-background" style={{ padding: '2rem', color: '#fff', maxWidth: '600px', margin: 'auto' }}>
      <h2 style={{ color: '#ffd700', marginBottom: '2rem' }}>Checkout</h2>
      <div
        style={{
          backgroundColor: '#002c6a',
          padding: '1.5rem',
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.4)',
        }}
      >
        <h3>{item.name}</h3>
        <p>{item.description}</p>
        <p><strong>Quantity:</strong> {qty}</p>
        <p><strong>Price per item:</strong> ₹{item.price}</p>
        <p><strong>Total Price:</strong> ₹{totalPrice}</p>
        <button className="primary-btn" style={{ marginTop: '1rem' }} onClick={handlePayment}>
          Pay ₹{totalPrice}
        </button>
      </div>
    </div>
  );
};

export default Checkout;
